export * from "expo-router/native-tabs";
// Panels have local selection state rather than filesystem routes. Keep Expo's experimental
// view API at the package boundary so both routed and embedded tabs use the same native host.
// SDK 58's wildcard exports resolve an exact .js file, bypassing Metro's platform suffixes.
// Embedded iOS panels must therefore request the iOS implementation explicitly.
export { NativeTabsView as NativeTabsViewIOS } from "expo-router/build/native-tabs/NativeTabsView.ios";
export type { NativeTabsViewProps, NativeTabOptions } from "expo-router/build/native-tabs/types";
// The generic converter ignores SF Symbols. Pin this to iOS too: package exports
// bypass Metro's platform resolution for this deep import just as for the view above.
export { appendIconOptions as appendIconOptionsIOS } from "expo-router/build/native-tabs/utils/optionsIconConverter.ios";
